import React from 'react';
import Select, {components, SingleValue} from 'react-select';

type Props = {
    type: string
    options: any[]
    value: {label: string, value: string} | null
    onChange: (value: SingleValue<{label:string, value:string}>) => void
    placeholder: string
    hasSelectedValue: boolean
}

const CustomMenuList = (props: any) => {
    return (
        <div data-lenis-prevent={true}>
            <components.MenuList {...props}/>
        </div>
    )
}

const SelectFilter: React.FC<Props> = (props) => {
    return (
        <div className={'select-filter'}>
            <Select
                options={props.options[0]}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                unstyled={false}
                isClearable={true}
                isSearchable={false}
                defaultMenuIsOpen={false}
                components={{MenuList: CustomMenuList}}
                styles={{
                    menuList: (base) => ({
                        ...base,
                        "::-webkit-scrollbar": {
                            width: "4px",
                            height: "0px",
                        },
                        "::-webkit-scrollbar-track": {
                            background: "var(--color-background-200)"
                        },
                        "::-webkit-scrollbar-thumb": {
                            background: "var(--color-primary-200)"
                        }
                    })
                }}
                classNamePrefix={'react-select'}/>
        </div>
    )
}

export default SelectFilter
